import axios from 'axios';
import React, { useEffect, useState } from 'react';
import styles from './userlist.module.css'

const UserCard = ({ user }) => (
  <div className={styles.card}>
    <h2>{user.name}</h2>
    <p>{user.email}</p>
  </div>
);

const UserList = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_HOST1}/auth/list`,        {
        headers: {
          "Content-Type": "application/json",
          accessToken: localStorage.getItem("accessToken"),
        },
      }).then((response) => {
          console.log(response.data);
          setUsers(response.data);
        });
    
  }, []);

  return (
    <div>
        <h1>Accounts in Database</h1>
      {users.map(user => (
        <UserCard key={user.id} user={user} />
      ))}
    </div>
  );
};

export default UserList;